'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  width: fit-content;
  margin: auto;
  @media screen and (width > ${theme.sizes.screens.md}) {
    width: initial;
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
`;
